export const chartsStepOptions = {
  today: 'HH:00',
  hourly: 'DD/MM HH:00',
  daily: 'DD/MM/YYYY',
};
